import React, { useState } from "react";
import "../css/appStyling.css";
import Navbar from "./Navbar";
import BackToHome from "./BackToHome";
export default function TextUtils(props) {
  // State to hold the text input
  const [userInput, setInput] = useState("");
  // for setting errors
  const [defaultMessage, setMessage] = useState("");

  const handleInputChange = (event) => {
    // console.log(event.target.value);
    // Update the state with the input text
    setInput(event.target.value);
  };
  const handleUpperCase = () => {
    // Convert text to uppercase
    if (userInput) {
      setInput(userInput.toUpperCase());
      setMessage("");
    } else {
      setMessage("Please enter a valid input");
    }
  };
  const handleLowerCase = () => {
    // Convert text to uppercase
    if (userInput) {
      setInput(userInput.toLowerCase());
      setMessage("");
    } else {
      setMessage("Please enter a valid input");
    }
  };
  const handleCopyContent = () => {
    if (userInput) {
      navigator.clipboard.writeText(userInput);
      setMessage("Text Copied Successfully");
    } else {
      setMessage("Please enter a valid input");
    }
  };
  const handleClear = () => {
    setMessage("");
    setInput("");
  };

  return (
    <>
    <Navbar/>
      <div className="textAreaContainer container p-4">
        <h1>Text Utility</h1>
        <p className="fw-bolder">{props.heading}</p>
        <textarea value={userInput} onInput={handleInputChange}></textarea>{" "}
        <br />
        <p className="error">{defaultMessage}</p>
        <div className="text-center">
          <button
            type="button"
            onClick={handleUpperCase}
            className="btn-textUtil"
          >
            UPPERCASE
          </button>
          <button
            type="button"
            onClick={handleLowerCase}
            className="btn-textUtil"
          >
            lowercase
          </button>
          <button type="button" onClick={handleClear} className="btn-textUtil">
            Clear Text
          </button>
          <button
            type="button"
            onClick={handleCopyContent}
            className="btn-textUtil"
          >
            Copy Content
          </button>
        </div>
        <h5>Preview Area: </h5>
       <p style={{    fontSize: '.75em', 
    whiteSpace: 'break-spaces'}}>
       {userInput}
       </p>
        <h4 className="my-3">Summary: </h4>
        {userInput.trim() === ""
          ? 0
          : `${userInput}`.split(" ").length} words {" , "}
        {userInput.trim() === "" ? 0 : `${userInput}`.split("").length}{" "}
        Characters <br />
        {userInput.trim() === ""
          ? 0
          : Math.round(`${userInput}`.split(" ").length * 0.01).toFixed(2)}{" "}
        Minutes to read
      </div>
      <BackToHome/>
    </>
  );
}
